// https://stackoverflow.com/questions/39553105/drawing-curved-svg-arrow-lines-from-div-to-div

import * as $ from "jquery";

declare const TweenLite: any;
declare const TimelineLite: any;
declare const Elastic: any;

const MorphSVGPlugin = require("./lib/gsap/MorphSVGPlugin");

export default class OurStory {
	page: HTMLElement;
	anchors: any;
	navItems: HTMLLinkElement[];

	activeSectionIndex: number;

	headerSpacerHeight: number;
	lastScrollPosition: number;

	tlThickness: any;
	tlFounder: any;
	tlPeople: any;
	tlMap: any;

	tlScoops: any[];
	elScoops: SVGElement[];

	constructor(el: HTMLElement) {
		this.tlScoops = [];
		this.elScoops = [];
		this.lastScrollPosition = -1;
		this.activeSectionIndex = 0;

		this.page = el;
		this.anchors = $('[data-anchor]');

		$('.wtf-navigation__wrapper > a').each((i, link) => {
			$(link).on("click", (e) => {
				e.preventDefault();
				const section = $(link).attr("data-section");
				this.scrollToSection(section);
			});
		});

		// Connect all anchor points with SVG elements
		this.connectAnchors();

		// Create all section timelines.
		this.initTimelines();

		// Start the scroll loop, watch for scroll events
		this.scrollLoop();
	}

	scrollLoop() {
		if (this.lastScrollPosition == window.pageYOffset) {
			requestAnimationFrame(() => {
				this.scrollLoop();
			});
			return false;
		} else {
			this.lastScrollPosition = window.pageYOffset;
			// Loop through sections to determine how far user has travelled
			$('.wtf-section').each((i, el) => {
				this.calculateSectionTravel(<HTMLElement>el);
			});

			this.calculateActiveSection();

			this.calculateConnectorTravel();
		}
		requestAnimationFrame(() => {
			this.scrollLoop();
		});
	}

	calculateSectionTravel(el:HTMLElement) {
		let checkBottom = this.lastScrollPosition + $(window).innerHeight();

		let top = $(el).offset().top;
		let center = $(el).height() / 2;
		let checkPoint = top + center;

		if (checkPoint < checkBottom && checkPoint > this.lastScrollPosition) {
			let distanceFromBottom = checkBottom - checkPoint;
			let travelPercent = ((distanceFromBottom / $(window).innerHeight()) * 100).toFixed(0);

			this.updateTimelines(el.getAttribute("data-section"), parseInt(travelPercent));
		}
	}

	calculateActiveSection() {
		$('.wtf-section').each((i, section) => {
			let checkBottom = this.lastScrollPosition + $(window).innerHeight();

			let top = $(section).offset().top;
			let center = $(section).height() / 2;
			let checkPoint = top + center;

			if (checkPoint < checkBottom && checkPoint > this.lastScrollPosition) {
				let distanceFromBottom = checkBottom - checkPoint;
				let travelPercent = ((distanceFromBottom / $(window).innerHeight()) * 100).toFixed(0);
				this.activeSectionIndex = i;
			}
		});

		this.updateNavigation();
	}

	scrollToSection(section:string) {
		this.updateHeaderSpacerHeight();
		const scrollTopPx = $('.wtf-section[data-section="'+section+'"]').offset().top - this.headerSpacerHeight;
		$('html, body').stop().animate({
			scrollTop: scrollTopPx
		}, 1600);
	}

	updateNavigation() {
		const activeClass = "wtf-navigation__item--active";
		$('.wtf-navigation__wrapper > a').each((i, item) => {
			if (i == this.activeSectionIndex) {
				$(item).addClass(activeClass);
			} else {
				$(item).removeClass(activeClass);
			}
		});
	}

	calculateConnectorTravel() {
		let checkBottom = this.lastScrollPosition + $(window).innerHeight();

		this.elScoops.forEach((el, i) => {
			const thisTop = $(el).offset().top;

			let top = $(el).offset().top;
			let center = $(el).height() / 2;
			let checkPoint = top + center;

			if (checkPoint < checkBottom && checkPoint > this.lastScrollPosition) {
				let distanceFromBottom = checkBottom - checkPoint;
				let travelPercent = ((distanceFromBottom / $(window).innerHeight()) * 100).toFixed(0);

				this.updateScoopTimeline(i, parseInt(travelPercent));
			}
		});
	}

	updateTimelines(section:string, percent:number) {
		switch (section) {
			case "thickness":
				this.tlThickness.progress(percent / 100);
				break;

			case "founder":
				this.tlFounder.progress(percent / 100);
				break;

			case "people":
				this.tlPeople.progress(percent / 100);
				break;

			case "map":
				this.tlMap.progress(percent / 100);
				break;
		}
	}

	updateScoopTimeline(index:number, percent:number) {
		// console.log('Updating scoop '+index+': ' + percent.toString());
		this.tlScoops[index].progress(percent / 100);
	}

	initTimelines() {
		this.initIntro();
		this.initThickness();
		this.initFounder();
		this.initPeople();
		this.initMap();
	}

	initIntro() {
		// Pop in the milkshake on page load
		TweenLite.fromTo(".wtf-section__intro img.wtf-product", 2, {
			opacity: 0,
			scale: 0.5,
			rotation: -45,
			transformOrigin: "center"
		}, {
			opacity: 1,
			scale: 1,
			delay: 1.5,
			rotation: 0,
			ease: Elastic.easeOut
		});

		// Create sparkles and paths
		const targetElA = '#sparkle-a';
		const targetElB = '#sparkle-b';
		const targetElC = '#sparkle-c';
		const pathDataA = MorphSVGPlugin.pathDataToBezier('#sparkle-path-a', {align: targetElA});
		const pathDataB = MorphSVGPlugin.pathDataToBezier('#sparkle-path-b', {align: targetElB});

		const tlIntro = new TimelineLite();

		tlIntro.set(targetElA, {xPercent: -53, yPercent: -43});
		tlIntro.set(targetElB, {xPercent: -62, yPercent: -47});

		tlIntro.set({},{},"+=1");

		tlIntro.fromTo(targetElA, 2, {opacity: 0, scale: 1.5}, {opacity: 1, scale: 1}, "rotation");
		tlIntro.fromTo(targetElB, 2, {opacity: 0, scale: 1.5}, {opacity: 1, scale: 1}, "rotation");
		tlIntro.fromTo(targetElC, 2, {opacity: 0, scale: 1.5}, {opacity: 1, scale: 1}, "rotation");

		tlIntro.to(targetElA, 30, {
			ease: "linear",
			bezier: {
				values: pathDataA,
				type: "cubic"
			},
			repeat: -1
		}, "rotation");

		tlIntro.to(targetElB, 30, {
			ease: "linear",
			bezier: {
				values: pathDataB,
				type: "cubic"
			},
			repeat: -1
		}, "rotation");

		tlIntro.fromTo(targetElC, 60, {
			rotation: 0
		}, {
			rotation: -360,
			repeat: -1,
			ease: "linear"
		}, "rotation");

		tlIntro.set({},{},"+=4");
	}

	initThickness() {
		// console.info("WTF: Thickness section timeline");
		this.tlThickness = new TimelineLite();
		this.tlThickness.staggerFrom(".wtf-section__thickness .sections path", 0.5, {
			opacity: 0,
			scale: 1.2,
			transformOrigin: "center"
		}, 0.25)
		.from(".wtf-section__thickness .arrow path", 0.1, {
			opacity: 0
		}, "arrow")
		.staggerFrom(".wtf-section__thickness .label", 1.5, {
			opacity: 0,
			scale: 1.2,
			transformOrigin: "center"
		}, 0.25, "arrow")
		.from(".wtf-section__thickness .arrow path", 3, {
			transformOrigin: "8% 88%",
			rotation: -135,
		}, "-=2")
		.set({},{},"+=2");

		this.tlThickness.pause();
	}

	initFounder() {
		// console.info("WTF: Founder section timeline");
		this.tlFounder = new TimelineLite();
		this.tlFounder.staggerFromTo(".wtf-section__founder .lightbulb .bolt", 1, {
			opacity: 0
		}, {
			opacity: 1
		}, 0.15)
		.to(".wtf-section__founder .lightbulb .bulb", 0.5, {
			fill: "#FFCC5F"
		}, "-=1")
		.to(".wtf-section__founder .lightbulb .bulb-center", 0.5, {
			fill: "#FFF"
		}, "-=1.125")

		.from(".wtf-section__founder .dude-arm", 1, {
			rotation: -55,
			transformOrigin: "100% 33%"
		}, "-=1")

		.to(".wtf-section__founder .eyebrow-left", 0.5, {
			rotation: -10,
			transformOrigin: "0 50%"
		}, "-=0.5")
		.to(".wtf-section__founder .eyebrow-right", 0.5, {
			rotation: 10,
			transformOrigin: "100% 50%"
		}, "-=0.5")

		.set({},{},"+=2");

		this.tlFounder.pause();
	}

	initPeople() {
		// console.info("WTF: People section timeline");
		this.tlPeople = new TimelineLite();
		this.tlPeople.set({},{},"+=0.25");
		this.tlPeople.staggerFromTo(".wtf-section__people .person", 1, {
			scale: 0.7,
			opacity: 0,
			transformOrigin: "center"
		}, {
			scale: 1.2,
			opacity: 1,
		}, 0.5)

		.staggerFromTo(".wtf-section__people .person .cup", 1, {
			scale: 0,
			transformOrigin: "center"
		}, {
			scale: 1.2
		}, 0.1, "-=1.5")

		.set({},{},"+=2.5");

		this.tlPeople.pause();
	}

	initMap() {
		// console.info("WTF: Map section timeline");
		this.tlMap = new TimelineLite();
		this.tlMap.set({},{},"+=2");

		this.tlMap.staggerFromTo(".wtf-section__map g.cups path", 10, {
			scale: 0,
			transformOrigin: "center"
		}, {
			scale: 1,
			translateY: 0,
			ease: Elastic.easeOut.config(1, 0.2)
		}, 1)

		.set({},{},"+=250");

		this.tlMap.pause();
	}

	updateHeaderSpacerHeight() {
		this.headerSpacerHeight = 0;
		$('body > div[role="presentation"]').each((i, el) => {
			const thisHeight = $(el).height();
			this.headerSpacerHeight = this.headerSpacerHeight + thisHeight;
		});
	}

	connectAnchors() {
		// Calculate the height of the fixed header spacer
		this.updateHeaderSpacerHeight();

		// Loop through all anchors on the page.
		$(this.anchors).each((i, anchor) => {
			// The first two anchors should be connecting
			// two sections, mark odd anchors as the start
			let isVisible = (i % 2) ? false : true;
			if (i < (this.anchors.length - 1) && isVisible) {
				const nextAnchor = this.anchors[i+1];

				// Calculate element's offsets relative to page
				let posA = {
					x: $(anchor).offset().left,
					y: ($(anchor).offset().top - this.headerSpacerHeight)
				};
				let posB = {
					x: $(nextAnchor).offset().left,
					y: ($(nextAnchor).offset().top - this.headerSpacerHeight)
				};

				// Calculate the connecting SVG position/dimensions
				const svgLeft = (posA.x < posB.x) ? posA.x : posB.x;
				const svgWidth = (posA.x < posB.x) ? posB.x - posA.x : posA.x - posB.x;
				const svgHeight = posB.y - posA.y;

				// Create a new SVG element to connect the anchor points
				const newSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
				// Set the SVG viewBox attribute with a little padding
				$(newSvg).attr('viewBox', '-5 -5 '+(svgWidth + 5).toFixed(0)+' '+(svgHeight + 5).toFixed(0));
				$(newSvg).attr("data-scoop", i.toString());
				$(newSvg).addClass("scoop-path"); // All 'scoop-path' elements share styles, assign class
				// Set the SVG height/width
				$(newSvg).attr({
					height: svgHeight.toFixed(0),
					width: svgWidth.toFixed(0),
				});
				// Position the SVG absolutely on the page
				$(newSvg).css({
					top: posA.y,
					left: svgLeft,
				});

				// Determine the path's start/end points based on anchor starting point
				let pathStart = {x:0, y:0};
				let pathEnd = {x:0, y:0};
				if (posA.x < posB.x) {
					pathStart = {x:0, y:0};
					pathEnd = {x:svgWidth, y:svgHeight}
				} else {
					pathStart = {x:svgWidth, y:0};
					pathEnd = {x:0, y:svgHeight};
				}

				let scoopStart = {x:posA.x, y:posA.y};

				// Create coords string of new path connecting the anchors
				const newPathD = "M" +
					(pathStart.x) + "," + (pathStart.y) + " " +
					"C" +
					(pathStart.x + 10) + "," + (pathStart.y + 200) + " " +
					(pathEnd.x - 10) + "," + (pathEnd.y - 200) + " " +
					(pathEnd.x) + "," + (pathEnd.y);

				// Create a new path, namespace is important
				const newPath = document.createElementNS("http://www.w3.org/2000/svg","path");
				newPath.setAttributeNS(null, "fill", "none");
				newPath.setAttributeNS(null, "class", "motion-path");
				// Create a new "d" attribute using the calculated path coords
				newPath.setAttributeNS(null, "d", newPathD);

				// Add the new path to the new SVG
				newSvg.appendChild(newPath);

				// Append the new SVG to the main.wtf element
				this.page.appendChild(newSvg);

				// Generate a scoop, place it in the DOM
				const scoopSide = (posA.x < posB.x) ? "left" : "right";
				const scoopSvg = this.createScoopSvg(i, scoopStart, scoopSide);
				this.page.appendChild(scoopSvg);

				// Create a scoop timeline for this connection
				this.createScoopTimeline(i);
			}
		});
	}

	createScoopSvg(i:number, scoopStart:any, side:string = "left") {
		const scoopDims = {
			width: 99.4,
			height: 146.9
		};

		// Create a new Scoop element for this path
		const newScoop = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		newScoop.setAttributeNS(null, "viewBox", "0 0 "+scoopDims.width+" "+scoopDims.height);
		newScoop.setAttributeNS(null, "class", "scoop");
		newScoop.setAttributeNS(null, "data-scoop", i.toString());
		newScoop.setAttributeNS(null, "height", scoopDims.height.toString());
		newScoop.setAttributeNS(null, "width", scoopDims.width.toString());
		newScoop.style.height = scoopDims.height.toString() + "px";
		newScoop.style.width = scoopDims.width.toString() + "px";

		const scoopPathA = document.createElementNS("http://www.w3.org/2000/svg","path");
		scoopPathA.setAttributeNS(null, "d", "M32.9,128.6c-.2-.1-5.4-.4-5.6-.7s5.6-22.1,5.6-22.1L14.2,89l15.5-5.5,9.8,1.7,6.3-20.5h5.4l5.1,4.9,4,14.6,21.2,2.6-.6,6.4L66.4,103.5l2.3,9.2L71,125.2l-3.3,2.9-18.8-11L35.2,129ZM94,42.3H4.9V54.8H94Z");
		scoopPathA.setAttributeNS(null, "style", "fill:#FFF;");
		newScoop.appendChild(scoopPathA);

		const scoopPathB = document.createElementNS("http://www.w3.org/2000/svg","path");
		scoopPathB.setAttributeNS(null, "d", "M37.9,36.2,22.7,0,19.2,2l9.1,33.8L3.2,35.2,0,38.4V57.3l3.2,3.2H8.4l8,83.3,62.9,3,9.5-84.7,10.5-4.8V39.7ZM76.1,92.5l-16.9,9.8,8.1,19.5v.7c0,.9-.4,1.7-1.4,1.7a2.3,2.3,0,0,1-1.4-.4l-15.6-10-16,10.8a3.3,3.3,0,0,1-1.3.4,1.6,1.6,0,0,1-1.5-1.8,1.3,1.3,0,0,1,.1-.6l5.2-18.2L20.1,91.8a3,3,0,0,1-.8-1.7c0-1,1.1-1.4,1.9-1.6H40.8l6.4-19c.3-.6.9-1.4,1.7-1.4s1.4.8,1.7,1.4L58,87.1l17.1,2.2c.8.1,1.9.5,1.9,1.6A2.2,2.2,0,0,1,76.1,92.5ZM90.9,50.4l-1.7,1.7H10.1L8.4,50.4V46.6l1.7-1.7H89.2l1.7,1.7Z");
		scoopPathB.setAttributeNS(null, "style", "fill:#EE3A43");
		newScoop.appendChild(scoopPathB);

		// const scoopPathC = document.createElementNS("http://www.w3.org/2000/svg","path");
		// scoopPathC.setAttributeNS(null, "d", "m 45.5,25.2 -0.9,0.9 H 5 L 4.1,25.2 V 23.3 L 5,22.4 h 39.6 l 0.9,0.9 z");
		// scoopPathC.setAttributeNS(null, "style", "fill:#FFF;");
		// newScoop.appendChild(scoopPathC);


		$(newScoop).css({
			top: scoopStart.y,
			left: scoopStart.x,
		});

		return newScoop;
	}

	createScoopTimeline(index:number) {
		// console.log("Creating timeline for scoop: " + index.toString());
		const targetPath = '.scoop-path[data-scoop="'+index.toString()+'"] .motion-path';
		const targetEl = '.scoop[data-scoop="'+index.toString()+'"]';
		const pathData = MorphSVGPlugin.pathDataToBezier(targetPath, {align: "relative"});

		const tlScoop = new TimelineLite();

		tlScoop.set(targetEl, {
			force3D: true,
			xPercent: -50,
			yPercent: -50,
		});

		if (index > 0) {
			tlScoop.set(targetEl, {
				force3D: false,
				// rotationY: 90,
				opacity: 0,
				scale: 0
			});
		} else {
			tlScoop.set(targetEl, {
				force3D: false,
				opacity: 1,
				scale: 1
			});
		}

		tlScoop.to(targetEl, 2, {
			rotationY: 0,
			scale: 1,
			opacity: 1,
			force3D: false,
		});

		tlScoop.to(targetEl, 10, {
			force3D: false,
			// ease: "linear",
			bezier: {
				values:pathData,
				type:"cubic",
				// autoRotate: -90
			}
		}, 0.5);
		tlScoop.to(targetEl, 2, {
			force3D: false,
			scale: 1.3,
			opacity: 0
		}, "-=2");
		tlScoop.pause();

		this.tlScoops.push(tlScoop);
		const thisScoop = <SVGElement>document.querySelector('.scoop-path[data-scoop="'+index.toString()+'"]');
		this.elScoops.push(thisScoop);
	}
}